import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { ISlimScrollOptions } from 'ng2-slimscroll';

import { environment } from '../../../environments/environment';
import { AppService } from '../../app.service';
import { OnBoardingService } from './../on-boarding.service';
import { UtilityFunctions } from './../../shared/utility-functions';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { MessageEvent, HandleSideMenuWithAuth, SignInEvent, OpenFrameEvent, LoaderEvent, SidemenuSubCategory, HiddenFooter, SetAllMemberCheck } from './../../shared/message.event';
import { AuthGuard } from '../../shared/auth-guard';

@Component({
    selector: 'app-on-boarding-dashboard',
    templateUrl: './on-boarding-dashboard.component.html',
    styleUrls: ['./on-boarding-dashboard.component.css'],
    providers: [
        AppService,
        OnBoardingService,
        MessageEvent,
        SignInEvent,
        OpenFrameEvent,
        LoaderEvent,
        SidemenuSubCategory,
        HiddenFooter,
        SetAllMemberCheck,
        AuthGuard
    ],
    exportAs: 'onBoarding'
})
export class OnBoardingDashboardComponent implements OnInit {

    private utilityFunctions = new UtilityFunctions();
    private vendor;
    private popUpMessage = '';
    private popupTitle = '';
    private scrollOptions: ISlimScrollOptions;
    private member: any = {
        'vendorId': '',
        'members': []
    };
    private booking: any = {
        'vendorId': '',
        'bookings': []
    };
    private addedMembers: any = {
        'vendorId': '',
        'members': [],
        'clubName': '',
        isWaitForCallback: true
    };
    private nextTab;
    @ViewChild('fileUploadInput')
    fileUploadInputVariable: any;
    @ViewChild("tab1") tab1;
    @ViewChild("tab2") tab2;
    @ViewChild("tab3") tab3;
    @ViewChild("tab4") tab4;
    @ViewChild("tab5") tab5;
    @ViewChild("tab6") tab6;
    @ViewChild("tab7") tab7;
    @ViewChild("done") done;
    @ViewChild("next") next;
    @ViewChild("bar1") bar1;
    @ViewChild("bar2") bar2;
    @ViewChild("bar3") bar3;
    @ViewChild("bar4") bar4;
    @ViewChild("bar5") bar5;
    @ViewChild("step1") step1;
    @ViewChild("step2") step2;
    @ViewChild("step3") step3;
    @ViewChild("step4") step4;
    @ViewChild("step5") step5;
    @ViewChild('bookingFileUploadInput')
    bookingFileUploadInputVariable: any;
    private successfullyAddedMembers = [];
    private unsuccessfullMembers;
    private logList = [];
    private messageFOrInvalidTemplate = '';
    private failedLogObj = [];
    private uiSetting;
    private height;
    private count = 0;
    private shouldSlide: boolean = false;
    private bookingLogList = [];
    private confirmBookingList = [];
    private sentInvitesList = [];
    private noInvitesList = [];
    private bookingCsvPath = CONSTANT_VALUES.BOOKING_CSV_PATH_UAT;
    private membersCsvPath = CONSTANT_VALUES.MEMBER_CSV_PATH_UAT;
    private hideNext = true;
    private hideDone = false;
    private cancelButtonInPopup = false;

    constructor(private appService: AppService, private handleSideMenuWithAuth: HandleSideMenuWithAuth, private router: Router, private onBoardingService: OnBoardingService, private openFrameEvent: OpenFrameEvent, private messageEvent: MessageEvent, private signInEvent: SignInEvent,
        private loaderEvent: LoaderEvent, private sidemenuSubCategory: SidemenuSubCategory, private hiddenFooter: HiddenFooter, private authGuard: AuthGuard) {
        this.uiSetting = {
            'windowHeight': window.innerHeight,
            'topNav': 56,
            'midNav': 45,
            'footer': 35,
            'container': 30
        }
        this.scrollOptions = {
            barBackground: "#343a40", barOpacity: "1", position: "right",
            barWidth: "12px", barBorderRadius: "5px", barMargin: "1px 0", gridBackground: "#adb5bd", gridOpacity: "1", gridWidth: "8px", gridBorderRadius: "10px", gridMargin: "1px 2px"
        };
        this.height = 0;
        // calculating height of current frame
        this.height = (this.uiSetting.windowHeight - (this.uiSetting.topNav + this.uiSetting.midNav + this.uiSetting.container + this.uiSetting.footer)) + 'px';
    }

    ngOnInit() {
        this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
        this.vendor.isFirstTimeLogin = false;
        localStorage.setItem('vendor', btoa(JSON.stringify(this.vendor)));
        this.emitOpenFrameEvent();
        this.registerTypeBroadcast();
       // localStorage.setItem('Wizard', btoa(JSON.stringify('Done')));
        this.setTemplateUrlByEnvironment();
    }
    /**
     * Upload member file for add member
     * 
     * @param {any} event 
     * @param {any} popupObj 
     * 
     * @memberof OnBoardingDashboardComponent
     */
    uploadFile(event, popupObj) {
        let input = event.target;
        let file = input.files[0];
        let that = this;
        this.successfullyAddedMembers = [];
        if (file.name.indexOf('.csv') !== -1) {
            this.utilityFunctions.getMembersFromFile(input).then((result) => {
                that.fileUploadInputVariable.nativeElement.value = '';
                that.failedLogObj = result['logList'];
                that.member.members = result['members'];
                if (result['message'] === CONSTANT_MESSAGES.INVALID_FILE_COLUMNS) {
                    that.popUpMessage = result['message'];
                    that.cancelButtonInPopup = true;
                    popupObj.showChildModal();
                } else {
                    if (that.member.members && that.member.members.length > 0) {
                        that.member.vendorId = this.vendor._id;
                        that.loaderEvent.fire(false);
                        that.onBoardingService.uploadMembers(this.member).then((result: any) => {
                            if (result.status === 'SUCCESS') {
                                if (result.notAdded && result.notAdded.length > 0) {
                                    result.notAdded.filter(function (rec) {
                                        that.failedLogObj.push({ obj: rec, logList: rec['reason'] });
                                    });
                                }
                                if (result.added && result.added.length > 0) {
                                    result.added.filter(function (rec) {
                                        that.successfullyAddedMembers.push({ obj: rec, logList: CONSTANT_MESSAGES.REMARK_MEMBER });
                                    });
                                }
                                if (result.updated && result.updated.length > 0) {
                                    result.updated.filter(function (rec) {
                                        that.successfullyAddedMembers.push({ obj: rec, logList: CONSTANT_MESSAGES.REMARK_MEMBER });
                                    });
                                }
                            } else {
                                that.loaderEvent.fire(true);
                                that.popUpMessage = result['message'];
                                popupObj.showChildModal();
                            }
                            if (that.successfullyAddedMembers && that.successfullyAddedMembers.length <= 0) {
                                that.hideDone = true;
                            } else {
                                that.hideNext = true;
                            }
                            that.loaderEvent.fire(true);
                        });
                    } else {
                    }
                    that.hideState('tab2');
                    that.displayState('tab3');
                    that.count++;
                    that['step2'].nativeElement.classList.add('halfProgress');
                }
            });
        } else {
            this.popUpMessage = CONSTANT_MESSAGES.FILE_NOT_SUPPORT;
            this.cancelButtonInPopup = true;
            popupObj.showChildModal();
        }
    }
    /**
     * Upload booking file to book activity in bulk
     * 
     * @param {any} event 
     * @param {any} popupObj 
     * 
     * @memberof OnBoardingDashboardComponent
     */
    uploadBookingFile(event, popupObj) {
        let input = event.target;
        let file = input.files[0];
        let that = this;
        let obj;
        this.bookingLogList = [];
        this.confirmBookingList = [];
        let bookingList = [];
        if (file.name.indexOf('.csv') !== -1) {
            this.utilityFunctions.getBookingsFromFile(input).then((result) => {
                this.resetBookingFileUploadInput();
                if (result['message'] === CONSTANT_MESSAGES.INVALID_FILE_COLUMNS) {
                    this.popUpMessage = CONSTANT_MESSAGES.INVALID_FILE_COLUMNS;
                    this.cancelButtonInPopup = true;
                    popupObj.showChildModal();
                }
                else {
                    this.bookingLogList = result['loglList'];
                    bookingList = result['booking'];
                    if (bookingList && bookingList.length > 0) {
                        let requestObj = {
                            'vendorId': this.vendor._id,
                            'bookings': bookingList
                        }
                        this.onBoardingService.uploadBookings(requestObj).then((result: any) => {
                            if (result.status === 'SUCCESS') {
                                if (result.notAdded && result.notAdded.length > 0) {
                                    result.notAdded.filter(function (rec) {
                                        that.bookingLogList.push({ obj: rec, logList: rec['reason'] });
                                    });
                                }
                                if (result.added && result.added.length > 0) {
                                    result.added.filter(function (rec) {
                                        that.confirmBookingList.push({ obj: rec, logList: rec['reason'] });
                                    });
                                }
                                this.loaderEvent.fire(true);
                            } else {
                                that.loaderEvent.fire(true);
                                that.popUpMessage = result['message'];
                                popupObj.showChildModal();
                            }
                        });
                    } else {
                    }
                    this.hideState('tab4');
                    this.count++;
                    this.hideNext = true;
                    this.displayState('tab5');
                    this['step3'].nativeElement.classList.add('halfProgress');
                }
            });
        } else {
            this.popUpMessage = CONSTANT_MESSAGES.FILE_NOT_SUPPORT;
            this.cancelButtonInPopup = true;
            popupObj.showChildModal();
        }
    }
    /**
     * Reset file upload input variable 
     * 
     * 
     * @memberof OnBoardingDashboardComponent
     */
    resetBookingFileUploadInput() {
        this.bookingFileUploadInputVariable.nativeElement.value = '';
    }
    /**
     * Send mail to invite member after booking
     * 
     * @param {any} popUpObj 
     * 
     * @memberof OnBoardingDashboardComponent
     */
    sendMailToAddedMembers(popupObj) {
        this.loaderEvent.fire(false);
        /* //Added this code to show message on service failure..
         setTimeout(function () {
                this.popupTitle = 'Error';
                this.popUpMessage = 'Something Went Wrong. Service returned error';
                this.appService.showPopup = popUpObj;
         },300);*/
        let that = this;
        that.addedMembers.vendorId = this.vendor._id;
        that.addedMembers.clubName = this.vendor.clubName;
        let obj;
        if (that.successfullyAddedMembers && that.successfullyAddedMembers.length > 0) {
            that.successfullyAddedMembers.forEach(function (rec) {
                that.addedMembers.members.push(rec['obj']);
            });
            that.addedMembers.isWaitForCallback = true;
            this.onBoardingService.sendMailToMembers(that.addedMembers).then((result: any) => {
                if (result.status === 'SUCCESS') {
                    if (result.members && result.members.length > 0) {
                        that.sentInvitesList =_.cloneDeep(result.members);
                        // result.members.forEach(function (rec) {
                        //     if (rec['isSent'] === true) {
                        //         that.sentInvitesList.push(rec);
                        //     } else {
                        //         if (rec) {
                        //             that.noInvitesList.push(rec);
                        //         }
                        //     }
                        // });
                        this.hideState('tab6');
                        this.displayState('tab7');
                        this.count++;
                        this.hideDone = true;
                        this.loaderEvent.fire(true);
                        this['step4'].nativeElement.classList.add('halfProgress');
                        this['step5'].nativeElement.classList.add('processfull2');
                        this['bar5'].nativeElement.classList.add('processFull');
                    }
                } else {
                    this.loaderEvent.fire(true);
                    that.popUpMessage = result['message'];
                    popupObj.showChildModal();
                }
            });
        } else {
            this.loaderEvent.fire(true);
        }
    }
    /**
     * Fire flag to adjust side menu bar
     * 
     * 
     * @memberof OnBoardingDashboardComponent
     */
    emitOpenFrameEvent() {
        this.openFrameEvent.fire(false);
    }


    registerTypeBroadcast() {
        this.messageEvent.on().subscribe(message => {
            this.shouldSlide = message;
        });
    }
    /**
     * Shoe the tab on next click
     * 
     * 
     * @memberof OnBoardingDashboardComponent
     */
    showNextActionOfWizard() {
        this.count++;
        let wizardDivsArr = ['tab1', 'tab2', 'tab3', 'tab4', 'tab5', 'tab6', 'tab7'];

        for (var i = 0; i < wizardDivsArr.length; i++) {
            if (this.count === i) {
                this[wizardDivsArr[i]].nativeElement.classList.add('displayTab');
                this.checkCounter();
            } else {
                this[wizardDivsArr[i]].nativeElement.classList.remove('displayTab');
                this[wizardDivsArr[i]].nativeElement.classList.add('hideTab');
            }
            this.hideNext = false;
        }
    }

    redirectToMemberPage(flag) {
        if (flag) {
            this.vendor.isFirstTimeLogin = false;
            localStorage.setItem('vendor', btoa(JSON.stringify(this.vendor)));
           // this.handleSideMenuWithAuth.fire({ fire: 'on', role: this.vendor.role, isFeedbackEnabled: this.vendor.isFeedbackEnabled });
            this.router.navigate(['/']);
        }
    }
    /**
     * Add the class to display given tab
     * 
     * @param {any} tab 
     * 
     * @memberof OnBoardingDashboardComponent
     */
    displayState(tab) {
        this[tab].nativeElement.classList.remove('hideTab');
        this[tab].nativeElement.classList.add('displayTab');
    }
    /**
     *  Add the class to hide tab
     * 
     * @param {any} tab 
     * 
     * @memberof OnBoardingDashboardComponent
     */
    hideState(tab) {
        this[tab].nativeElement.classList.remove('displayTab');
        this[tab].nativeElement.classList.add('hideTab');
    }
    /**
     * Show popup to close the wizard
     * 
     * @param {any} popupObj 
     * @param {any} title 
     * 
     * @memberof OnBoardingDashboardComponent
     */
    confirmFinish(popupObj, title) {
        this.popupTitle = title;
        this.cancelButtonInPopup = true;
        this.popUpMessage = CONSTANT_MESSAGES.FINISH_WIZARD;
        popupObj.showChildModal();
    }
    /**
     * Show progress bar as per wizard proceed 
     * 
     * 
     * @memberof OnBoardingDashboardComponent
     */
    checkCounter() {
        switch (this.count) {
            case 1:
                this['step1'].nativeElement.classList.add('processFull');
                this['step2'].nativeElement.classList.add('processfull2');
                this['bar2'].nativeElement.classList.add('processFull');
                break;
            case 3:
                this['step3'].nativeElement.classList.add('processfull2');
                this['bar3'].nativeElement.classList.add('processFull');
                break;
            case 5:
                this['step4'].nativeElement.classList.add('processfull2');
                this['bar4'].nativeElement.classList.add('processFull');
                break;
        }
    }

    /**
     * Set Download template url as per the environment
     * 
     * 
     * @memberof OnBoardingDashboardComponent
    * */
    setTemplateUrlByEnvironment() {
        switch (environment.envName) {
            case 'dev':
                this.bookingCsvPath = CONSTANT_VALUES.BOOKING_CSV_PATH;
                this.membersCsvPath = CONSTANT_VALUES.MEMBER_CSV_PATH;
                break;
            case 'qa':
                this.bookingCsvPath = CONSTANT_VALUES.BOOKING_CSV_PATH_QA;
                this.membersCsvPath = CONSTANT_VALUES.MEMBER_CSV_PATH_QA;
                break;
            case 'uat':
                this.bookingCsvPath = CONSTANT_VALUES.BOOKING_CSV_PATH_UAT;
                this.membersCsvPath = CONSTANT_VALUES.MEMBER_CSV_PATH_UAT;
                break;
            case 'prod':
                this.bookingCsvPath = CONSTANT_VALUES.BOOKING_CSV_PATH_PROD;
                this.membersCsvPath = CONSTANT_VALUES.MEMBER_CSV_PATH_PROD;
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/on-boarding/on-boarding-dashboard/on-boarding-dashboard.component.ts